import config from "../../config";

const getPOEditorLocalization = async (projectName, locale) => {
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify({
      projectName,
      locale,
    }),
  };

  try {
    const response = await fetch(
      config.POEditor.awsLocalizationUrl,
      requestOptions
    )

    const localization = await response.json();

    return localization;
  } catch (error) {
    throw error;
  }
};

export default getPOEditorLocalization;



// WEBPACK FOOTER //
// ./src/js/hocs/I18n/getPOEditorLocalization.js